import { get } from '../../lib/api/client';

/**
 * Open-alert count for the Main KPIs "Needs your attention" tile —
 * `GET /admin/alerts/open-count`. Every admin screen reader may see the
 * number, even without access to the alerts themselves (they can remind an
 * admin). The alert list and acknowledging live in `features/money`.
 */
export async function getOpenAlertCount(signal?: AbortSignal): Promise<number> {
  return (await get<{ open: number }>('/admin/alerts/open-count', undefined, signal)).open;
}
